import React, { useState, useEffect } from "react";
import { Link, NavLink, useParams } from "react-router-dom";

import LeftSidebar from "../Common/LeftSidebar";
import Loader from "../Common/Loader";
import RightIconMenu from "../Common/RightIconMenu";
import RightSidebar from "../Common/RightSidebar";

import { username, role, token, roleid } from "../Actions/AuthAction";
import {
  addCandidateImage,
  singleCandidatesDetails,
  actionUploadResume,
  actionGetResume,
} from "../Actions/CandidateAction";
import Swal from "sweetalert2";

import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import ProfileForms from "../profile-forms";
import { EditProfile } from "./EditProfile";
import ImageUpload from "../profile-forms/components/image-upload";

import config from "../../config";
import moment from "moment";

const Profile = () => {
  const [showEdit, setShowEdit] = useState(false);
  const [step, setstep] = useState(1);
  const [modalHeading, setmodalHeading] = useState("");
  const [candidateDetails, setCandidateDetails] = useState([]);
  const [resumeDetails, setResumeDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  const pid = useParams().id;
  useEffect(() => {
    loadData();
  }, []);
  const loadData = () => {
    const model = { loginusertoken: token(), id: pid != "" ? pid : "" };
    singleCandidatesDetails(model)
      .then((res) => {
        setCandidateDetails(res.data);
        console.log(res.data);

        const model1 = { loginusertoken: token(), id: res.data[0].id };
        actionGetResume(model1)
          .then((res) => {
            if (res.status) {
              setResumeDetails(res.data);
              console.log("resume", res.data.file);
            } else {
              setResumeDetails("noresume");
              console.log("resume", res.data.file);
            }
          })
          .catch((err) => {
            // if(err.response.status === 401){
            // 	window.location.reload();
            // }
          });
      })
      .catch((err) => {
        // if(err.response.status === 401){
        // 	window.location.reload();
        // }
      });
  };
  const handleClose = () => {
    setShowEdit(false);
  };
  const imageUpdate = (imageList) => {
    setLoading(true);
    addCandidateImage({
      loginusertoken: token(),
      profilepic: imageList[0].data_url,
    }).then((res) => {
      console.log(res);
      loadData();
      setLoading(false);
    });
  };

  const [showPdfSubmit, setShowPdfSubmit] = useState(false);

  const sampleImage = "../../assets/img/profile128.png";
  const uploadOfferLetter = (values) => {
    values.preventDefault();

    const reader = new FileReader();
    reader.readAsDataURL(showPdfSubmit);
    reader.onload = (data) => {
      let json = JSON.stringify(reader.result);

      let str1 = "";
      json.split("/").map((item, index) => {
        if (index != 0) {
          if (index == json.split("/").length - 1) {
            str1 += item;
          } else {
            str1 += item + "/";
          }
        }
      });
      const jsonToPost = {
        loginusertoken: token(),
        resume: "data:@file/" + str1,
      };

      actionUploadResume(jsonToPost).then((res) => {
        if (res.status) {
          Swal.fire("Resume Uploaded Successfully", "", "success");
          window.location.reload();
        } else {
          Swal.fire("OOPS Something went wrong", "", "warning");
        }
        console.log(res);
      });

      setShowPdfSubmit(false);
    };
  };
  return (
    <React.Fragment>
      {loading && <Loader />}
      <div class="row">
        {showEdit ? (
          <EditProfile
            handleClose={handleClose}
            step={step}
            heading={modalHeading}
            data={candidateDetails[0]}
            loadData={loadData}
            setLoading={setLoading}
          />
        ) : (
          ""
        )}
        <div class="col-md-12">
          <div class="card formcard p-4">
            <div class="row">
              <div class="col-md-2">
                <div style={{ width: 180, height: 180, margin: "0 auto;" }}>
                  <CircularProgressbar value={100} />
                </div>
                {/* <img src="assets/img/user.jpg" class="profilepic" /> */}
                <img
                  src={
                    candidateDetails && candidateDetails.length != 0
                      ? `${config.IMAGE_URL}/${candidateDetails[0].profilepic}`
                      : "data:image/png;base64,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"
                  }
                  className="profilepic"
                />
              </div>
              <div class="col-md-10">
                <div class="mobile-block">
                  <h2>
                    {candidateDetails.length > 0
                      ? candidateDetails[0].firstname
                      : ""}{" "}
                    {candidateDetails.length > 0
                      ? candidateDetails[0].middlename
                      : ""}{" "}
                    {candidateDetails.length > 0
                      ? candidateDetails[0].lastname
                      : ""}
                  </h2>
                  <span>
                    <i class="fa fa-user"></i>{" "}
                    {candidateDetails.length > 0
                      ? candidateDetails[0].rollnumber
                      : ""}
                  </span>

                  <span>
                    <i class="fa fa-building"></i>{" "}
                    {candidateDetails.length > 0
                      ? candidateDetails[0].inst.name
                      : ""}
                  </span>

                  <span>
                    <i class="fa fa-university"></i>{" "}
                    {candidateDetails.length > 0
                      ? candidateDetails[0].uni.university_name
                      : ""}
                  </span>

                  {roleid() == 5 && (
                    <div class="mt-3">
                      <ImageUpload
                        className="btn btn-primary-custom mx-2 mb-2"
                        onImageSelect={imageUpdate}
                      />
                      <Link
                        class="btn btn-secondary-custom mx-2 mb-2"
                        to="/changepassword"
                      >
                        Change Password
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 co-sm-12 col-xs-12">
          <div class="card formcard my-3">
            <div class="card-body">
              <div class="d-flex justify-content-between  border-bottom">
                <h4 class="table_heading position-relative">
                  PERSONAL DETAILS
                </h4>
                {roleid() == 5 && (
                  <div class="header-btn">
                    <button
                      class="btn btn-secondary-custom mx-2 d-block mb-2"
                      onClick={() => {
                        setShowEdit(true);
                        setstep(1);
                        setmodalHeading("PERSONAL DETAILS");
                      }}
                    >
                      Edit
                    </button>
                  </div>
                )}
              </div>
              <div class="d-flex justify-content-between pt-3 joblisting">
                <div class="col-md-4">
                  <ul>
                    <li>Date of Birth:</li>
                    <li>Gender:</li>
                    <li>Fathers Name:</li>
                    <li>Mobile No.</li>
                    <li>Email Id.</li>
                    <li>Alternate No.:</li>
                    <li>Address:</li>
                    <li>City:</li>
                    <li>State:</li>
                    <li>Pincode:</li>
                    <li>Prefred Location:</li>
                    <li>Skills:</li>
                  </ul>
                </div>
                <div class="col-md-8">
                  <ul>
                    <li>
                      {candidateDetails.length > 0 ? moment(candidateDetails[0].dob).format('DD MMM YYYY') : ""}
                      {/* {candidateDetails.length > 0
                        ? candidateDetails[0].dob.split(" ")[0]
                        : ""} */}
                    </li>
                    <li>
                      {candidateDetails.length > 0
                        ? candidateDetails[0].gender == 1
                          ? "Male"
                          : "Female"
                        : ""}
                    </li>
                    <li>
                      {candidateDetails.length > 0
                        ? candidateDetails[0].fathersname
                        : ""}
                    </li>
                    <li>
                      {candidateDetails.length > 0
                        ? candidateDetails[0].user.phone
                        : ""}
                    </li>
                    <li>
                      {candidateDetails.length > 0
                        ? candidateDetails[0].user.email
                        : ""}
                    </li>
                    <li>
                      {candidateDetails.length > 0 &&
                        candidateDetails[0].alternatenumber
                        ? candidateDetails[0].alternatenumber
                        : "-"}
                    </li>
                    <li>
                      {candidateDetails.length > 0
                        ? candidateDetails[0].address
                        : ""}
                    </li>
                    <li>
                      {candidateDetails.length > 0
                        ? candidateDetails[0].city.name
                        : ""}
                    </li>
                    <li>
                      {candidateDetails.length > 0
                        ? candidateDetails[0].state.name
                        : ""}
                    </li>
                    <li>
                      {candidateDetails.length > 0
                        ? candidateDetails[0].pincode
                        : ""}
                    </li>

                    <li>
                      {candidateDetails.length > 0 &&
                        candidateDetails[0].candidatepreferredlocations.map(
                          (item) => (
                            <span class="badge badge-pill badge-secondary mx-1">
                              {item.preferredlocation0.name}
                            </span>
                          )
                        )}
                    </li>

                    <li style={{ maxHeight: "fit-content" }}>
                      {candidateDetails.length > 0 &&
                        candidateDetails[0].candidateskills.map((item) => (
                          <span class="badge badge-pill badge-secondary mx-1">
                            {item.skills.skillname}
                          </span>
                        ))}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 co-sm-12 col-xs-12">
          <div class="card formcard my-3">
            <div class="card-body">
              <div class="d-flex justify-content-between  border-bottom">
                <h4 class="table_heading position-relative">
                  EDUCATIONAL DETAILS
                </h4>
                {roleid() == 5 && (
                  <div class="header-btn">
                    <button
                      class="btn btn-secondary-custom mx-2 d-block mb-2"
                      onClick={() => {
                        setShowEdit(true);
                        setstep(2);
                        setmodalHeading(" EDUCATIONAL DETAILS");
                      }}
                    >
                      Edit
                    </button>
                  </div>
                )}
              </div>
              <div class="d-flex justify-content-between pt-3 joblisting">
                <div class="table-responsive">
                  <table
                    class="table table-bordered"
                    width="100%"
                    cellspacing="0"
                  >
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Name</th>
                        <th>College/School</th>
                        <th>Board/University</th>
                        {/* <th>Qualification Type</th> */}
                        <th>Year of Passing</th>
                        <th>Percentage</th>
                      </tr>
                    </thead>
                    <tbody>
                      {candidateDetails.length > 0 &&
                        candidateDetails[0].candidatequalificationmaps.map(
                          (item, index) => (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{item.qualificationname}</td>

                              <td>{item["collage/school"]}</td>
                              <td>{item["board/University"]}</td>
                              {/* <td>{item.qualificationtype}</td> */}
                              <td>{item.yearofpassing}</td>
                              <td>{item.percentage}</td>
                            </tr>
                          )
                        )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 co-sm-12 col-xs-12">
          <div class="card formcard my-3">
            <div class="card-body">
              <div class="d-flex justify-content-between  border-bottom">
                <h4 class="table_heading position-relative">PROJECTS</h4>
                {roleid() == 5 && (
                  <div class="header-btn">
                    <button
                      class="btn btn-secondary-custom mx-2 d-block mb-2"
                      onClick={() => {
                        setShowEdit(true);
                        setstep(3);
                        setmodalHeading("PROJECTS");
                      }}
                    >
                      Edit
                    </button>
                  </div>
                )}
              </div>
              <div class="d-flex justify-content-between pt-3 joblisting">
                <div class="table-responsive">
                  <table
                    class="table table-bordered"
                    width="100%"
                    cellspacing="0"
                  >
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Name</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Description</th>
                        <th>Duration</th>
                      </tr>
                    </thead>
                    <tbody>
                      {candidateDetails.length > 0 &&
                        candidateDetails[0].candidateprojects.map(
                          (item, index) => (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{item.propjectname}</td>
                              <td>{moment(item.startdate).format('D-MMM-YY')}</td>
                              <td>{moment(item.enddate).format('D-MMM-YY')}</td>
                              <td>{item.projectdescription}</td>
                              <td>{item.projectduration}</td>
                            </tr>
                          )
                        )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 co-sm-12 col-xs-12">
          <div class="card formcard my-3">
            <div class="card-body">
              <div class="d-flex justify-content-between  border-bottom">
                <h4 class="table_heading position-relative">
                  CERTIFICATIONS,TRAINING & AWARDS
                </h4>
                {roleid() == 5 && (
                  <div class="header-btn">
                    <a
                      class="btn btn-secondary-custom mx-2 d-block mb-2"
                      onClick={() => {
                        setShowEdit(true);
                        setstep(4);
                        setmodalHeading(" CERTIFICATIONS,TRAINING & AWARDS");
                      }}
                    >
                      Edit
                    </a>
                  </div>
                )}
              </div>
              <div class="d-flex justify-content-between pt-3 joblisting">
                <div class="table-responsive">
                  <table
                    class="table table-bordered"
                    width="100%"
                    cellspacing="0"
                  >
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Name</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Description</th>
                        <th>Duration</th>
                      </tr>
                    </thead>
                    <tbody>
                      {candidateDetails.length > 0 &&
                        candidateDetails[0].candidatetrainings.map(
                          (item, index) => (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{item.trainingrole}</td>
                              <td>{moment(item.startdate).format('D-MMM-YY')}</td>
                              <td>{moment(item.enddate).format('D-MMM-YY')}</td>
                              <td>{item.trainingdiscription}</td>
                              <td>{item.traningduration}</td>
                            </tr>
                          )
                        )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 co-sm-12 col-xs-12">
          <div class="card formcard my-3">
            <div class="card-body">
              <div class="d-flex justify-content-between  border-bottom">
                <h4 class="table_heading position-relative">Resume</h4>
                <div class="header-btn">
                  {resumeDetails != "noresume" ? (
                    <>
                      <span>{moment(resumeDetails.date).format('DD-MMM-YYYY')}</span>
                      <a
                        href={`${config.IMAGE_URL}/${resumeDetails.file}`}
                        target="_blank"
                        class="btn btn-secondary-custom mx-2 mb-2"
                      >
                        View
                      </a>
                      <a
                        href={`${config.IMAGE_URL}/${resumeDetails.file}`}
                        download
                        class="btn btn-primary-custom mx-2 mb-2"
                      >
                        Download
                      </a>
                    </>
                  ) : (
                    <>
                      <p>No Resume Found</p>
                    </>
                  )}
                </div>
              </div>
              <div class="d-flex justify-content-between pt-3 joblisting">
                <div class="table-responsive">
                  <table className="table table-hover">
                    <tbody>
                      {roleid() == 5 ? (
                        <tr>
                          <th scope="row" className="border-top-0">
                            Upload Resume
                          </th>
                          <td className="border-top-0">:</td>
                          <td className="border-top-0">
                            <form onSubmit={uploadOfferLetter}>
                              <label
                                className="small mb-1 btn btn-primary"
                                for="offerLetter"
                              >
                                {resumeDetails != "noresume"
                                  ? "Update"
                                  : " Choose"}
                              </label>

                              <input
                                type="file"
                                hidden
                                accept=".pdf,.doc,.docx"
                                id="offerLetter"
                                onChange={(e) => {
                                  setShowPdfSubmit(e.target.files[0]);
                                }}
                              ></input>
                              {showPdfSubmit ? (
                                <button
                                  type="submit"
                                  className="small mb-1 btn btn-success ml-2 "
                                >
                                  Submit
                                </button>
                              ) : null}
                            </form>
                          </td>
                        </tr>
                      ) : (
                        ""
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div class="row mt-5">
                                <div class="col-xl-3 col-md-6">
                                    <div class="card-custom card mb-4">
                                        <div class="card-body d-flex justify-content-between">
                                            <h5>Universities
                                                <span class="d-block text-danger mt-4">20</span>
                                            </h5>
                                            <h2 class="text-danger dashboardicon"> <i class="d-block text-danger dashboardiconimg fas fa-university"></i></h2>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-3 col-md-6">
                                    <div class="card-custom card mb-4">
                                        <div class="card-body d-flex justify-content-between">
                                            <h5>Institutions
                                                <span class="d-block text-danger mt-4">1</span>
                                            </h5>
                                            <h2 class="text-danger dashboardicon"> <i class="d-block text-danger dashboardiconimg fas fa-building"></i></h2>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-3 col-md-6">
                                    <div class="card-custom card mb-4">
                                        <div class="card-body d-flex justify-content-between">
                                            <h5>Recruiters
                                                <span class="d-block text-danger mt-4">3</span>
                                            </h5>
                                            <h2 class="text-danger dashboardicon"> <i class="d-block text-danger dashboardiconimg fas fa-user-secret"></i></h2>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-3 col-md-6">
                                    <div class="card-custom card mb-4">
                                        <div class="card-body d-flex justify-content-between">
                                            <h5>Employers
                                                <span class="d-block text-danger mt-4">4</span>
                                            </h5>
                                            <h2 class="text-danger dashboardicon"> <i class="d-block text-danger dashboardiconimg fas fa-graduation-cap"></i></h2>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-3 col-md-6">
                                    <div class="card-custom card mb-4">
                                        <div class="card-body d-flex justify-content-between">
                                            <h5>Candidates
                                                <span class="d-block text-danger mt-4">4000</span>
                                            </h5>
                                            <h2 class="text-danger dashboardicon"> <i class="d-block text-danger dashboardiconimg fas fa-users"></i></h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card mb-4">
                                <div class="card-header">
                                    Table
                                </div>
                                <div class="card-body">
                                    <div class="table-responsive">
                                        <table class="table table-bordered" width="100%" cellspacing="0">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Position</th>
                                                    <th>Office</th>
                                                    <th>Age</th>
                                                    <th>Start date</th>
                                                    <th>Salary</th>
                                                </tr>
                                            </thead>
                                            <tbody>                                               
                                                <tr>
                                                    <td>Shad Decker</td>
                                                    <td>Regional Director</td>
                                                    <td>Edinburgh</td>
                                                    <td>51</td>
                                                    <td>2008/11/13</td>
                                                    <td>$183,000</td>
                                                </tr>
                                                <tr>
                                                    <td>Michael Bruce</td>
                                                    <td>Javascript Developer</td>
                                                    <td>Singapore</td>
                                                    <td>29</td>
                                                    <td>2011/06/27</td>
                                                    <td>$183,000</td>
                                                </tr>
                                                <tr>
                                                    <td>Donna Snider</td>
                                                    <td>Customer Support</td>
                                                    <td>New York</td>
                                                    <td>27</td>
                                                    <td>2011/01/25</td>
                                                    <td>$112,000</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div  class="d-flex justify-content-between">
                                        <h6>Showing 1-10 results from 50</h6>
                                        <ul class="d-flex justify-content-between list-unstyled pagination">
                                            <li class="px-1"><a href="#"><i class="fa fa-angle-double-left" aria-hidden="true"></i></a></li>       
                                            <li class="px-1 active"><a href="#">1</a></li>                                            
                                            <li class="px-1"><a href="#">2</a></li>                                            
                                            <li class="px-1"><a href="#">3</a></li>
                                            <li class="px-1"><a href="#">4</a></li>  
                                            <li class="px-1"><a href="#">5</a></li>                                            
                                            <li class="px-1"><a href="#"><i class="fa fa-angle-double-right" aria-hidden="true"></i></a></li>       
                                        </ul>
                                    </div>
                                </div>
                            </div> */}
    </React.Fragment>
  );
};
export default Profile;
